export const transformIntoMoney = (value: number, fractionDigits: number = 0) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
};

export const round = (value: number, precision: number): number => {
  const multiplier = 10 ** (precision || 0);
  return Math.round(value * multiplier) / multiplier;
};

export const numberToDelimited = (num: number): string => num.toLocaleString('en-US');

// https://stackoverflow.com/a/40724354/3086270
export const abbreviateNumber = (number: number): string => {
  const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
  const tier = (Math.log10(Math.abs(number)) / 3) | 0;

  if (tier === 0) return String(number);

  const suffix = SI_SYMBOL[tier];
  const scale = Math.pow(10, tier * 3);
  const scaled = number / scale;
  const formatted = scaled.toFixed(number % scale ? 1 : 0);

  return formatted + suffix;
};

export const delimitedToNumber = (delimited: string | number): number =>
  typeof delimited === 'string' ? Number(delimited.replace(/\D/g, '')) : delimited;

export const delimitedToNumberWithNullable = (delimited: string | number): number | null => {
  if (typeof delimited !== 'string') return delimited;

  if (!delimited) return null;

  return Number(delimited.replace(/\D/g, ''));
};

type MapRange = [number, number];
export const mapNumberInRange = (
  value: number,
  [startRangeMin, startRangeMax]: MapRange,
  [resultRangeMin, resultRangeMax]: MapRange,
): number =>
  ((value - startRangeMin) * (resultRangeMax - resultRangeMin)) / (startRangeMax - startRangeMin) + resultRangeMin;

export const getOrdinalEnding = (num: number): string => {
  let ordinalEnding;
  const generalOridnalEnding = 'th';

  switch (num % 10) {
    case 1:
      ordinalEnding = num % 100 === 11 ? generalOridnalEnding : 'st';
      break;
    case 2:
      ordinalEnding = num % 100 === 12 ? generalOridnalEnding : 'nd';
      break;
    case 3:
      ordinalEnding = num % 100 === 13 ? generalOridnalEnding : 'rd';
      break;
    default:
      ordinalEnding = generalOridnalEnding;
  }

  return ordinalEnding;
};

export const isNumber = (val: number): val is number => isFinite(val);
